import {
  BottomSheetBackdrop,
  type BottomSheetBackdropProps,
  BottomSheetModal,
  BottomSheetScrollView,
} from "@gorhom/bottom-sheet"
import { useCallback, useEffect, useRef } from "react"
import { BFColors } from "@/constants/Colors"
import { Vertical } from "@/components/standard/BFLayout"
import { Body, H2 } from "@/components/standard/BFText"
import { ProgramDetailsButton } from "@/screens/rewards/components/ProgramDetailsButton"
import { AllRewards } from "@/screens/rewards/components/AllRewards"

export const ProgramInfoPopup = ({
  visible,
  onClose,
}: {
  visible: boolean
  onClose: () => void
}) => {
  const bottomSheetModalRef = useRef<BottomSheetModal>(null)

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => (
      <BottomSheetBackdrop
        {...props}
        appearsOnIndex={0}
        disappearsOnIndex={-1}
      />
    ),
    []
  )

  useEffect(() => {
    if (!bottomSheetModalRef.current) {
      return
    }

    if (visible) {
      bottomSheetModalRef.current.present()
    } else {
      bottomSheetModalRef.current.close()
    }
  }, [bottomSheetModalRef, visible])

  return (
    <BottomSheetModal
      onDismiss={onClose}
      ref={bottomSheetModalRef}
      backdropComponent={renderBackdrop}
      snapPoints={["90%"]}
      backgroundStyle={{ backgroundColor: BFColors.offWhite }}
      handleIndicatorStyle={{ backgroundColor: BFColors.calmBlue }}
    >
      <BottomSheetScrollView>
        <Vertical className={"px-5 py-10 gap-1"}>
          <H2 className={"text-center text-midnight-blue mb-3 "}>
            Backflip Rewards
          </H2>
          <Body className={"text-center text-midnight-blue mb-6 mx-4"}>
            The more deals you close, the more you save. Redeem discounts for
            bps off origination fees for future deals.
          </Body>

          <AllRewards />

          <ProgramDetailsButton />
        </Vertical>
      </BottomSheetScrollView>
    </BottomSheetModal>
  )
}
